import React from "react";
import { useTranslation } from "react-i18next";
import { FmUnderlineNav } from "..";
import { useIsMobile } from "../../Hooks";

import useStyles from "./FmRecommendedProduct.style";

interface FmRecommendedProductProps {
    img: any;
    title: string;
    volume?: string | number;
    method?: string;
    onLinkClick: () => void;
}

const FmRecommendedProduct = ({ img, title, volume, method, onLinkClick }: FmRecommendedProductProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    return (
        <div className={classes.container}>
            <div className={classes.leftSide}>
                <img src={img} alt='img' className={classes.img} />
            </div>
            <div className={classes.rightSide}>
                <div className={classes.firstCol}>
                    <div className={classes.title}>{title}</div>
                    {!isMobile && <FmUnderlineNav title={t("pageStep3.customize.topLink")} onClick={onLinkClick} />}
                </div>
                {!isMobile && (
                    <div className={classes.subTitle}>
                        {t("fmRecommendedProduct.volume")}: <span className={classes.boldText}>{volume}</span> | {t("fmRecommendedProduct.method")}:{" "}
                        <span className={classes.boldText}>{method}</span>
                    </div>
                )}
                {!isMobile && <div className={classes.description}>{t("pageStep3.recommendedProduct.description")}</div>}
                {isMobile && (
                    <div className={classes.graphLinkMobile}>
                        <FmUnderlineNav title={t("pageStep3.customize.topLink")} onClick={onLinkClick} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default FmRecommendedProduct;
